import { render, staticRenderFns } from "./home-new.vue?vue&type=template&id=1c3dd78d&scoped=true"
import script from "./home-new.vue?vue&type=script&lang=js"
export * from "./home-new.vue?vue&type=script&lang=js"
import style0 from "./home-new.vue?vue&type=style&index=0&id=1c3dd78d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3dd78d",
  null
  
)

export default component.exports